import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Box, Button, Container, Dialog, DialogContent, Grid, IconButton, Paper, Skeleton, Stack, Tooltip, Typography } from '@mui/material';
import { Chart as ChartJS, registerables } from "chart.js";
import { fr } from 'date-fns/locale';
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Bar } from 'react-chartjs-2';
import { DateRange } from "react-date-range";
import api from "../api";
import { useGetEmployees } from '../api/employee';


ChartJS.register(...registerables);

const Dashboard = (props) => {

    const [employees, setEmployees] = useState([])
    const [selectedRange, setSelectedRange] = useState({ startDate: null, endDate: null })
    const [modalDateOpen, setModalDateOpen] = useState(false)

    const [data, setData] = useState({
        bar_chart: {
            labels: [],
            datasets: []
        },
        individual_bar_chart: []
    })

    const { data: employeeData, error: employeeError } = useGetEmployees({ begin_date: selectedRange.startDate, end_date: selectedRange.endDate }, { enabled: selectedRange.startDate != null && selectedRange.endDate != null})


    useEffect(() => {
        getPeriod()
    }, [])


    useEffect(() => {
        getData()
    }, [selectedRange])

    useEffect(() => {
        if (employeeData) {
            setEmployees(employeeData.employees)
        }
    }, [employeeData])



    const getData = async () => {
        if (selectedRange.startDate && selectedRange.endDate) {
            let res = await api.get("/dashboard/", { begin_date: moment(selectedRange.startDate).format("YYYY-MM-DD"), end_date: moment(selectedRange.endDate).format("YYYY-MM-DD") })
            setData(res.data)
        }
    }

    const getPeriod = async () => {
        let res = await api.get('/time_period/', { date: moment().toISOString() })

        setSelectedRange({ key: "selection", startDate: new Date(res.data.begin_date), endDate: new Date(res.data.end_date) })
    }

    const getPreviousPeriod = async () => {
        let res = await api.get('/time_period/', { date: moment(selectedRange.startDate).subtract(1, "day").toISOString() })

        setSelectedRange({ key: "selection", startDate: new Date(res.data.begin_date), endDate: new Date(res.data.end_date) })
    }

    const getNextPeriod = async () => {
        let res = await api.get('/time_period/', { date: moment(selectedRange.endDate).add(1, "day").toISOString() })

        setSelectedRange({ key: "selection", startDate: new Date(res.data.begin_date), endDate: new Date(res.data.end_date) })
    }

    const formatTime = (time) => {
        time = parseFloat(time)
        let hours = Math.floor(time)
        let minutes = Math.round((time - Math.floor(time)) * 60)
        return hours.toString() + "h" + minutes.toString().padStart(2, '0')
    }

    const renderTimeByDayGraph = () => {
        if (!!!data) {
            return (
                <Skeleton variant="rectangular" height={300} />
            )
        }
        if (data.bar_chart.datasets.length === 0) {
            return (
                <Skeleton variant="rectangular" height={300} />
            )
        }
        return (
            <Box sx={{ height: 300 }}>
                <Bar
                    options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                stacked: true
                            },
                            x: {
                                stacked: true
                            }
                        },
                        plugins: {
                            tooltip: {
                                mode: 'index',
                                intersect: false,
                                position: 'nearest',
                                callbacks: {
                                    label: function (context) {
                                        let label = context.dataset.label || '';
                                        if (label) {
                                            label += ': ';
                                        }
                                        if (context.parsed.y !== null) {
                                            label += formatTime(context.parsed.y) + ' ' + "(" + context.parsed.y + ")";
                                        }
                                        return label;
                                    },
                                    footer: function (items) {
                                        let total = 0
                                        items.forEach(item => {
                                            total += item.parsed.y
                                        })
                                        return "Total: " + formatTime(total) + ' ' + "(" + total + ")";
                                    }
                                }
                            }
                        }
                    }}
                    data={data.bar_chart}
                />
            </Box>
        )
    }

    const renderIndividualTimeByDayGraph = () => {
        if (!!!data) {
            return (
                <Skeleton variant="rectangular" height={300} />
            )
        }
        if (data.individual_bar_chart.length === 0) {
            return (
                <Skeleton variant="rectangular" height={300} />
            )
        }

        return (
            <Stack direction={"column"} spacing={1}>

                {data.individual_bar_chart.map((item, index) => {
                    return (
                        <Paper sx={{ p: 2 }} key={index}>
                            <Grid container  >
                                <Grid item xs={3}>
                                    <Typography variant="body1">{item.label}</Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="body1">{formatTime(item.data)}</Typography>
                                </Grid>
                                <Grid item xs={6} maxHeight={50}>
                                    <Bar
                                        id={"bar_chart_" + index}
                                        data={{
                                            datasets: [{
                                                label: "Temps réel",
                                                data: [item.data],
                                                backgroundColor: (item.data >= item.expected_number_of_hours ? "#82d5ff" : "#ff8a80")
                                            },
                                            {
                                                label: "Temps prévu",
                                                data: [item.expected_number_of_hours],
                                                backgroundColor: "#FFFFFF00"
                                            }],
                                            labels: [item.data.toFixed(2) + "/" + item.expected_number_of_hours.toFixed(2)]

                                        }}
                                        options={{
                                            indexAxis: 'y',
                                            responsive: true,
                                            maintainAspectRatio: false,
                                            scales: {
                                                y: {
                                                    stacked: true,
                                                    ticks: {
                                                        beginAtZero: true,
                                                    },
                                                    grid: {
                                                        display: false
                                                    },

                                                },
                                                x: {
                                                    ticks: {
                                                        display: false
                                                    },
                                                    grid: {
                                                        display: false
                                                    },
                                                    barPercentage: 0.5,
                                                    barThickness: 2,

                                                },

                                            },
                                            plugins: {
                                                tooltip: {
                                                    enabled: false,
                                                    mode: 'index',
                                                    callbacks: {
                                                        label: function (context) {
                                                            let label = context.dataset.label || '';
                                                            if (label) {
                                                                label += ': ';
                                                            }
                                                            if (context.parsed.y !== null) {
                                                                label += formatTime(context.parsed.x) + ' ' + "(" + context.parsed.x + ")";
                                                            }
                                                            return label;
                                                        },
                                                        footer: function (items) {
                                                            let total = 0
                                                            if (items[0].raw > items[1].raw) {
                                                                return "Temps additionnel: " + formatTime(items[0].raw - items[1].raw) + ' ' + "(" + (items[0].raw - items[1].raw) + ")";
                                                            }
                                                            else {
                                                                return "Temps manquant: " + formatTime(items[1].raw - items[0].raw) + ' ' + "(" + (items[1].raw - items[0].raw) + ")";
                                                            }
                                                            return "Total: " + formatTime(total) + ' ' + "(" + total + ")";
                                                        }
                                                    },
                                                    external: function (context) {
                                                        let tooltipEl = document.getElementById('chartjs-tooltip');

                                                        if (!tooltipEl) {
                                                            tooltipEl = document.createElement('div');
                                                            tooltipEl.id = 'chartjs-tooltip';
                                                            tooltipEl.innerHTML = '<table></table>';
                                                            tooltipEl.style.backgroundColor = "#FFF";
                                                            tooltipEl.style.border = "1px solid black";
                                                            tooltipEl.style.borderRadius = "5px";
                                                            tooltipEl.style.padding = "5px";

                                                            document.body.appendChild(tooltipEl);
                                                        }

                                                        // Hide if no tooltip
                                                        const tooltipModel = context.tooltip;
                                                        if (tooltipModel.opacity === 0) {
                                                            tooltipEl.style.opacity = 0;
                                                            return;
                                                        }

                                                        // Set caret Position
                                                        tooltipEl.classList.remove('above', 'below', 'no-transform');
                                                        if (tooltipModel.yAlign) {
                                                            tooltipEl.classList.add(tooltipModel.yAlign);
                                                        } else {
                                                            tooltipEl.classList.add('no-transform');
                                                        }

                                                        function getBody(bodyItem) {
                                                            return bodyItem.lines;
                                                        }

                                                        // Set Text
                                                        if (tooltipModel.body) {
                                                            const titleLines = tooltipModel.title || [];
                                                            const bodyLines = tooltipModel.body.map(getBody);

                                                            let innerHtml = '<thead>';

                                                            titleLines.forEach(function (title) {
                                                                innerHtml += '<tr><th>' + title + '</th></tr>';
                                                            });
                                                            innerHtml += '</thead><tbody>';

                                                            bodyLines.forEach(function (body, i) {
                                                                const colors = tooltipModel.labelColors[i];
                                                                let style = 'background:' + colors.backgroundColor;
                                                                style += '; border-color:' + colors.borderColor;
                                                                style += '; border-width: 2px';
                                                                const span = '<span style="' + style + '">' + body + '</span>';
                                                                innerHtml += '<tr><td>' + span + '</td></tr>';
                                                            });

                                                            const footer = tooltipModel.footer;
                                                            if (footer) {
                                                                innerHtml += '<tr><td>' + footer + '</td></tr>';
                                                            }

                                                            innerHtml += '</tbody>';

                                                            let tableRoot = tooltipEl.querySelector('table');
                                                            tableRoot.innerHTML = innerHtml;
                                                        }

                                                        const position = context.chart.canvas.getBoundingClientRect();

                                                        // Display, position, and set styles for font
                                                        tooltipEl.style.opacity = 1;
                                                        tooltipEl.style.position = 'absolute';
                                                        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX / 2 + 'px';
                                                        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                                                        tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
                                                        tooltipEl.style.pointerEvents = 'none';
                                                    }
                                                },
                                                legend: {
                                                    display: false
                                                },

                                            }
                                        }}

                                    />

                                </Grid>
                            </Grid>
                        </Paper>
                    )
                })}
            </Stack>
        )
    }




    return (
        <Container maxWidth={null} sx={{ pt: 2, pb: 2 }}>

            <Grid container spacing={2} sx={{ height: "100%" }}>
                <Grid item xs={12} md={12}>
                    <Paper sx={{ p: 2, height: "100%" }} elevation={10}>
                        <Stack direction={"row"} spacing={4}>
                            <Typography variant="h4">Statistiques</Typography>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <IconButton onClick={getPreviousPeriod}>
                                    <Tooltip title="Période précédente">
                                        <ChevronLeftIcon />
                                    </Tooltip>
                                </IconButton>
                                <Button onClick={() => setModalDateOpen(true)} variant="outlined" endIcon={<CalendarMonthIcon />}>
                                    <Typography variant="body1" sx={{ display: "inline-flex" }}>
                                        {selectedRange.startDate ? selectedRange.startDate.toLocaleDateString() : <Skeleton variant="text" width={50} />} - {selectedRange.endDate ? selectedRange.endDate.toLocaleDateString() : <Skeleton variant="text" width={50} />}
                                    </Typography>
                                </Button>
                                <IconButton onClick={() => getPeriod()}>
                                    <Tooltip title="Réinitialiser">
                                        <RestartAltIcon />
                                    </Tooltip>
                                </IconButton>
                                <IconButton onClick={getNextPeriod}>
                                    <Tooltip title="Période suivante">
                                        <ChevronRightIcon />
                                    </Tooltip>
                                </IconButton>
                            </Stack>
                        </Stack>
                    </Paper>
                </Grid>

                <Grid item xs={12} md={12}>
                    <Paper sx={{ p: 2, }} elevation={10}>
                        {renderTimeByDayGraph()}
                    </Paper>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Paper sx={{ p: 2 }} elevation={10}>
                        {renderIndividualTimeByDayGraph()}
                    </Paper>

                </Grid>
            </Grid>

            <Dialog open={modalDateOpen} onClose={() => setModalDateOpen(false)}  >
                <DialogContent sx={{ p: 2, width: "fit-content" }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        Choisir une période
                    </Typography>
                    <DateRange
                        locale={fr}
                        ranges={[{ key: 'selection', ...selectedRange }]}
                        onChange={(item) => setSelectedRange(item.selection)}
                        weekStartsOn={0}
                        months={1}
                        direction="horizontal"
                        editableDateInputs={true}
                        moveRangeOnFirstSelection={false}
                    />
                </DialogContent>
            </Dialog>
        </Container>
    )
}
export default Dashboard